<!-- vueui/src/components/Footer.vue -->
<template>
    <footer class="py-4 bg-dark text-white-50">
        <div class="container text-center">
            <small class="text-white-50">
                BPubM.com (BPM) &copy; {{ new Date().getFullYear() }} VP History, LLC — All Rights Reserved.
            </small>
            <div id="version">{{ latestVersion }}</div>
        </div>
    </footer>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'

export default defineComponent({
    setup() {
        const latestVersion = ref('loading...')

        onMounted(() => {
            fetch('/version.json')
                .then(response => response.json())
                .then((data: Record<string, string>) => {
                    // Filter out build duration items and only keep version items
                    const versionItems = Object.entries(data)
                        .filter(([key, value]) => 
                            key.endsWith('Version') && 
                            value && 
                            value !== 'loading...' && 
                            value !== 'unavailable'
                        )
                        .map(([key, value]) => value)
                    
                    // Sort versions and get the latest
                    const latest = versionItems.sort().reverse()[0]
                    latestVersion.value = `v${latest || 'unknown'}`
                })
                .catch(() => {
                    latestVersion.value = 'v: unavailable'
                })
        })

        return { latestVersion }
    }
})
</script>

<style scoped>
#version {
    font-size: 0.8rem;
    font-family: monospace;
    margin-top: 0.5rem;
    line-height: 1.3;
}
</style>
